<template>
  <div class="bottom-controls p-fixed w-100 d-flex">
    <router-link :to="{ name: 'ShowObjects' }" class="bottom-controls__items text-white p-relative">
      Объект
      <div class="control-items__dots p-absolute rounded-pill"></div>
    </router-link>
    <router-link :to="{ name: 'PurchaseTerms' }" class="bottom-controls__items text-white p-relative">
      Условия покупки
      <div class="control-items__dots p-absolute rounded-pill"></div>
    </router-link>
    <router-link :to="{ name: 'SelectByParameters' }" class="bottom-controls__items text-white p-relative">
      Подбор по параметрам
      <div class="control-items__dots p-absolute rounded-pill"></div>
    </router-link>
    <router-link :to="{ name: 'ObjectPhoto' }" class="bottom-controls__items text-white p-relative">
      Фото объекта
      <div class="control-items__dots p-absolute rounded-pill"></div>
    </router-link>
    <router-link :to="{ name: 'PropertyDescription' }" class="bottom-controls__items text-white p-relative">
      Описание объекта
      <div class="control-items__dots p-absolute rounded-pill"></div>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
